import axios from "axios"
import { useStoreActions, useStoreState } from "easy-peasy"
import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { beep } from "./beep.js"
import ErrorPopup from "./ErrorPopup.js"
import { READ_USER_MODULES_URL } from "./Constants.js"
import UserModuleFeed from "./UserModuleFeed.js"

// PURPOSE: Grant/Revoke module access to the named user.
//    The user is presented with a list of modules licensed by the city.
//    A checkbox is provided to grant/revoke access to the module
//    for a selected user.
const UserModules = () => {
	const { state } = useLocation() // access state from calling route
	const { user } = state // set the state into the user object
	const navigate = useNavigate()

	const [modules, setModules] = useState([])
	const [isInitialUser, setIsInitialUser] = useState(false)
	const [error, setError] = useState("")
	// easy-peasy
	const Token = useStoreState((state) => state.Token)
	const setGrants = useStoreActions((actions) => actions.setGrants)
	const selectedUser = useStoreState((state) => state.selectedUser)
	const setSelectedUser = useStoreActions((actions) => actions.setSelectedUser)
	const setLoggedIn = useStoreActions((actions) => actions.setLoggedIn)

	let suid = user[0] // Hold the selected user id
	setSelectedUser(suid) // Save for UserModuleList

	useEffect(() => { if (error) beep() }, [error])

	useEffect(() => {
		async function handleModules() {
			try {
				// Request data structure
				const request = {
					login_id: Token.login_id,
					client_id: Token.client_id,
					selected_user_id: suid,
				}
				const { data } = await axios.post(READ_USER_MODULES_URL, request)

				// Response data structure
				//    modules: list of licensed modules (module_id, module_name) ordered by name
				//    grants: list of user_modules (id,module_id,role) for selected_user_id un-ordered
				setModules(data.modules)
				setIsInitialUser(data.is_initial_user ?? false)
				// Save the grants, needed for userModuleList
				setGrants(data.grants)
			} catch (err) {
				setError(err.message)
				if (err.message === "Request failed with status code 422") {
					setLoggedIn(false)
					navigate("/login")
				}
			}
		}
		handleModules()
	}, [])

	return (
		<main className="Main">
			<fieldset
				style={{
					width: "fit-content",
					marginTop: "4rem",
					marginLeft: "auto",
					marginRight: "auto",
				}}
			>
				<legend>Grant User Access to Modules</legend>
				<h3>
					For User: {user[1]}, {user[2]}
				</h3>
				<h3>Email: {user[3]}</h3>
				{!error && <UserModuleFeed modules={modules} isInitialUser={isInitialUser} />}
				<ErrorPopup message={error ? (error.message || String(error)) : ""} onClose={() => setError("")} />
				<div style={{ marginTop: "0.75rem", textAlign: "center" }}>
					<button className="saveBtn" onClick={() => navigate("/user")}>List</button>
				</div>
			</fieldset>
		</main>
	)
}

export default UserModules
